import { render } from "./PaymentIcon.vue?vue&type=template&id=97977914&scoped=true"
import script from "./PaymentIcon.vue?vue&type=script&lang=js"
export * from "./PaymentIcon.vue?vue&type=script&lang=js"

import "./PaymentIcon.vue?vue&type=style&index=0&id=97977914&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97977914"]])

export default __exports__